import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nullText'
})
export class NullTextPipe implements PipeTransform {

  transform(input: string): string {
    if (null == input || "" == input) {
      return "-"
    } else {
      return input;
    }
  }
}
